var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ExternalLinkBox component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconExternalLinkBox extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41526 2.60498C3.20023 2.60498 2.99401 2.6904 2.84196 2.84245C2.68991 2.9945 2.60449 3.20072 2.60449 3.41575V20.5842C2.60449 20.7992 2.68991 21.0055 2.84196 21.1575C2.99401 21.3096 3.20023 21.395 3.41526 21.395H20.5837C20.7987 21.395 21.005 21.3096 21.157 21.1575C21.3091 21.0055 21.3945 20.7992 21.3945 20.5842V13.5608C21.3945 13.1465 21.7303 12.8108 22.1445 12.8108C22.5587 12.8108 22.8945 13.1465 22.8945 13.5608V20.5842C22.8945 21.1971 22.651 21.7848 22.2177 22.2182C21.7843 22.6515 21.1966 22.895 20.5837 22.895H3.41526C2.80241 22.895 2.21465 22.6515 1.7813 22.2182C1.34795 21.7848 1.10449 21.1971 1.10449 20.5842V3.41575C1.10449 2.8029 1.34795 2.21514 1.7813 1.78179C2.21465 1.34844 2.80241 1.10498 3.41526 1.10498H10.4387C10.8529 1.10498 11.1887 1.44077 11.1887 1.85498C11.1887 2.26919 10.8529 2.60498 10.4387 2.60498H3.41526Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.6112 1.26738C22.6578 1.30444 22.7 1.34693 22.7366 1.3939C22.7412 1.39973 22.7456 1.4056 22.75 1.41153C22.7652 1.43224 22.7792 1.45356 22.7921 1.47539C22.7965 1.48289 22.8007 1.49044 22.8048 1.49805C22.8624 1.60419 22.8951 1.72577 22.8951 1.85498V7.31767C22.8951 7.73189 22.5593 8.06767 22.1451 8.06767C21.7309 8.06767 21.3951 7.73189 21.3951 7.31767V3.66558L12.5303 12.5303C12.2374 12.8232 11.7626 12.8232 11.4697 12.5303C11.1768 12.2374 11.1768 11.7625 11.4697 11.4697L20.3343 2.60498H16.6824C16.2682 2.60498 15.9324 2.26919 15.9324 1.85498C15.9324 1.44077 16.2682 1.10498 16.6824 1.10498H22.145H22.1451C22.3212 1.10498 22.4832 1.16571 22.6112 1.26738Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconExternalLinkBox.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconExternalLinkBox.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconExternalLinkBox.prototype, "size", void 0);
if (customElements.get('cat-icon-external-link-box') === undefined) {
    customElements.define('cat-icon-external-link-box', BlocksIconExternalLinkBox);
}
